module.exports = __webpack_public_path__ + "static/media/doraemon.951c8090.jpg";